module.exports = __webpack_public_path__ + "static/media/Heart-Donation.8c95a757.png";